import { commonResponseBody } from "../utils/commonResponseBody";
export const getApiTemplate = {
  name: 'get',
  required: false,
  desc: '获取接口',
  dbMethod: 'get',
  request: {
    query: {
      title: 'url参数',
      type: 'object',
      required: false,
      fields: [{
        id: 'id',
        type: 'string',
        title: '对象id'
      }],
      useInDB: true
    },
    body: {
      title: '请求包体',
      type: 'object',
      required: false,
      fields: [{
        id: 'id',
        type: 'string',
        title: '对象id'
      }]
    }
  },
  response: {
    body: commonResponseBody('查询的对象', true)
  }
};
//# sourceMappingURL=get.js.map
